
export const environment = {
	production: false,
	
	//API_SECURITY: 'https://localhost:44324',
	API_SECURITY: 'http://187.189.134.143/dev/devsionapi',
	//HOWEN_API: 'http://www.gtmtec.mx:9966',
	HOWEN_API: 'http://187.189.134.158:9966',
	isMockEnabled: true,
	EXTERNAL_MAP: 'http://www.gtmtec.mx/dev/devsion',
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	firebaseConfig : {
		apiKey: "AIzaSyC2ZLARpH-7z45b42hjNntfL4YJppgIJbM",
		authDomain: "zigbee-73eb7.firebaseapp.com",
		databaseURL: "https://zigbee-73eb7-default-rtdb.firebaseio.com",
		projectId: "zigbee-73eb7",
		storageBucket: "zigbee-73eb7.appspot.com",
		messagingSenderId: "219472575289",
		appId: "1:219472575289:web:26b032e45076ffe88c46e8"
	  },
firebaseConfig1 : {
	apiKey: "AIzaSyDgMPNSbkuX1Doo1BhyouyWiiPWgMackPk",
	authDomain: "pruebainspeccion-8d5f2.firebaseapp.com",
	databaseURL: "https://pruebainspeccion-8d5f2-default-rtdb.firebaseio.com",
	projectId: "pruebainspeccion-8d5f2",
	storageBucket: "pruebainspeccion-8d5f2.appspot.com",
	messagingSenderId: "402724247254",
	appId: "1:402724247254:web:2e232fca6c652c388e1b77"
}
};
